export default __webpack_public_path__ + "static/media/2.3643d747.PNG";